// extracted by mini-css-extract-plugin
export default {"panel":"Panel-module__panel___ERxBc","header":"Panel-module__header___gY0X9","footer":"Panel-module__footer___rDWo_","content":"Panel-module__content___XO1cz"};